import { BrowserRouter, Switch, Route } from "react-router-dom";
import Success from "./pages/Success/Success";
import Terms from "./pages/Terms/Terms";
import ValidateTerms from "./pages/Validate/Validate";
import NotFound from "./components/NotFound/NotFound"
import HomeTerms from "./pages/HomeTerms/HomeTerms";
import { LoginGoogle } from "./pages/Login/Login";

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/validate/:id" component={ValidateTerms} />
        <Route exact path="/success" component={Success} />
        <Route exact path="/terms/:id" component={Terms} />
        <Route exact path="/" component={HomeTerms} />
        <Route exact path="/login/:id" component={LoginGoogle} />
        <Route
          path="/lojasedmil.com.br"
          component={() => {
            window.location.href = "https://www.lojasedmil.com.br/";
            return null;
          }}
        />
        <Route component={NotFound} />
        
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
